// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__DDD3R","dashboardText":"Dashboard_dashboardText__GQBsh"};